export default "__VITE_ASSET__Ch_4O6fo__"